import {z} from 'zod';

/**
 * Schema for GET /:id request parameters
 */
export const getPromptByIdRequestSchema = z.object({
  id: z.string().uuid(),
});
